import { useEffect, useRef, useState } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_PUR2010_R01 } from "./Content_PUR2010_R01";
import { Info_PUR2010_R01 } from "./Info_PUR2010_R01";
import { SearchSection_PUR2010_R01 } from "./SearchSection_PUR2010_R01";
import { usePUR2010_R01Store } from "./Store_PUR2010_R01";
import { AgGridReact } from "ag-grid-react";
import { PUR2010_R01DetailDto, PUR2010_R01Dto, PUR2010_R01HeaderDto } from "./Dto_PUR2010_R01";
import { Table_PUR2010_R01 } from "./Table_PUR2010_R01";
import { DetailTable_PUR2010_R01 } from "./DetailTable_PUR2010_R01";


export const Container_PUR2010_R01 = () => {

	const { 
		allCount,
		initData, 
		PUR2010_R01List, PUR2010_R01DetailList,
	} = usePUR2010_R01Store();

	
	const { moneyCdList, vatTypeList } = useCommonCodeStore();
	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'PUR2010_R01',
		type: 'width',
		storageKey: 'PUR2010_R01-split-width',
		min: 5,
		max: 80,
		default: 42
	} as const;
	const gridRef = useRef<AgGridReact<PUR2010_R01HeaderDto>>(null);
	const detailGridRef = useRef<AgGridReact<PUR2010_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);

	

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const V_RESIZER = {
		code: 'PUR2010_R01',
		type: 'height',
		storageKey: 'PUR2010_R01-info-split-height',
		min: 5,
		max: 80,
		default: 40
	} as const;
	const rightTopRef = useRef<HTMLDivElement>(null);
	const isVResizing = useRef(false);

	const { 
		splitValue: vSplitValue,
		handleMouseDown: handleVMouseDown,
	} = useMouseContent({
		resizer: V_RESIZER,
		isResizing: isVResizing,
		containerRef: infoRef,
		infoRef: rightTopRef
	});

	const {
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultPUR2010_R01HeaderRow,
		defaultPUR2010_R01DetailRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	} = Content_PUR2010_R01({
		gridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,		
	});

	useEffect(() => { 
		if (PUR2010_R01List.length === 0 && PUR2010_R01DetailList.length === 0) { handleCreateClick(); }
	}, [PUR2010_R01List, PUR2010_R01DetailList, handleCreateClick]);

	return <div className={`content-container`}>
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={handleCreateClick}
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={handlePrintClick}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_PUR2010_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_PUR2010_R01 gridRef={gridRef} defaultPUR2010_R01HeaderRow={defaultPUR2010_R01HeaderRow()} handleCreateClick={handleCreateClick} />
			</div>
			{/* 리사이저 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저"
			/>
			<div className="h-full flex flex-col gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={infoRef}>
				<div style={{ height: `${vSplitValue}%`, maxHeight: `${vSplitValue}%` }} ref={rightTopRef}>
					<Info_PUR2010_R01 
						editable={false}
						defaultPUR2010_R01HeaderRow={defaultPUR2010_R01HeaderRow()}
					/>
				</div>
				{/* 리사이저 */}
				<div
					className="h-[6px] bg-gray-100 cursor-row-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleVMouseDown("UD", e.nativeEvent) }
				/>
				<div style={{ height: `${100 - vSplitValue}%` }}>
					<DetailTable_PUR2010_R01 gridRef={detailGridRef} defaultPUR2010_R01DetailRow={defaultPUR2010_R01DetailRow()} />
				</div>
			</div>
		</div>
		<Message />
	</div>
}